module.exports = {
  defaultLocale: 'en',
  locales: ['en', 'fi', 'uk', 'es', 'pt'],
  apiUser: 'lovented_api',
  apiPass: 'OAsgo16423RA2wiu9jkaQOW1308u',
  port: 8080,
  businessHostUrl: 'https://business.choicely.com',
  supportHostUrl: 'https://support.choicely.com'
}
